import React from 'react';

const LoadingOverlay = ({
  isVisible,
  message = 'Loading...',
  style = {}
}) => {
  if (!isVisible) return null;

  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
    ...style
  };

  const messageStyle = {
    fontSize: '1.1rem',
    color: '#64748b',
    fontWeight: '500'
  };

  return (
    <div style={overlayStyle}>
      <div className="loading-spinner loading-spinner--md" />
      <div style={messageStyle}>{message}</div>
    </div>
  );
};

export default LoadingOverlay;
